<template>
  <div>
    <a-modal width="880px"
      title="人员指派"
      v-model:visible="modal.visible"
      :afterClose="close"
      :confirm-loading="modal.confirmLoading">

      <div class="info-wrap flex">
        <dl class="flex mr30">
          <dt>任务编号</dt>
          <dd>{{ modal.task.number }}</dd>
        </dl>
        <dl class="flex">
          <dt>任务名称：</dt>
          <dd>{{ modal.task.name }}</dd>
        </dl>
      </div>
      <a-form 
        ref="formRef"
        layout="inline"
        class="assign-form"
        :model="assignForm"
        :rules="assignForm.rules"
        :label-col="{ span: 5 }"
        :wrapper-col="{ span: 18 }">
        <div class="flex">
          <a-form-item class="flex" label="团队" name="team"> 
            <!-- <p> <span>{{ getTeamName(currentRole.teamId) }}</span></p> -->
            <a-input lablel="团队" class="form-select mr10" disabled :value="getTeamName(currentRole.teamId)" placeholder="选择团队"  />
            <!-- <a-select disabled  placeholder="选择团队" class="mr10 form-select">
              <a-select-option v-for="item in assignForm.teamList"
                :key="item.id" :addition="item.addition">
                ddd
              </a-select-option>
            </a-select> -->
          </a-form-item>
          <a-form-item class="flex" label="标注员" name="labeler">
            <a-select name="labeler" placeholder="选择标注员" class="mr10 form-select" v-model:value="assignForm.labeler">
              <a-select-option v-for="item in assignForm.labelerList" :value="item.userId"
                :key="item.userId" :addition="item.labeler">
                {{ item.username }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item class="flex" label="质检员" name="inspector" v-if="modal.task.labelType == 'online'">
            <a-select name="inspector" placeholder="选择质检员" class="form-select" v-model:value="assignForm.inspector">
              <a-select-option v-for="item in assignForm.inspectorList" :value="item.userId"
                :key="item.userId" :addition="item.inspector">
                {{item.username}}
              </a-select-option>
            </a-select>
          </a-form-item>
        </div>
      </a-form>
      <template v-slot:footer>
        <a-button key="back" @click="handleCancel">关闭</a-button>
        <a-button key="submit" type="primary" @click="handleOk">确定</a-button>
      </template>
    </a-modal>
  </div>
</template>


<script>


import {reactive, onMounted, computed, getCurrentInstance} from "vue";
import {mapState} from 'vuex'
import {useRoute, useRouter} from 'vue-router'
import { message } from 'ant-design-vue';
import { useStore } from '@/store/index2'

import { statusToCn, getRoleName, getTeamName } from '@/filters'

import {pageForServer,getForEdit,taskApprove,  labelTaskReceive, labelTaskReject, labelTaskSplit,labelTaskAssign,teamMembers} from '@/api/taskRelease'


export default{
  components:{
    
  },
  
  computed:{
    ...mapState(['userInfo', 'appConfig', 'rolesVisible', 'currentRole']),
  },
  props:['task'],
  emits:['close'],
  setup(props, context){
    const router = useRouter()
    const route = useRoute()
    const modal= reactive({
      visible:true,
      confirmLoading:false,
      task:computed(()=>{
        return props.task
      })
    })

    let assignForm = reactive({
      rules:{},
      teamList:[],
      team:'',
      roleId:'',
      inspectorList:[],
      labelerList:[],
      labelerOpt:[],
      inspector:'',
      labeler:''
    })



    let store = useStore()


    let {taskSatus,subtaskSatus,taskType } = store

    let instance = getCurrentInstance()

    //  获取标注员列表
    async function getLaber(){  
      let params = {
        roleId:17,
        teamId: instance.ctx.currentRole.teamId
      }
      debugger
      let {data:res} = await teamMembers(params)
      res.data.forEach((item)=>{
        assignForm.labelerList.push({
          userId:item.userId,
          username:item.username, 
        })
      })

      getInspector()
    
    } 

    // 获取质检员列表
    async function getInspector(){  
      let params = {
        roleId:18,
        teamId: instance.ctx.currentRole.teamId
      }
 
      let {data:res} = await teamMembers(params)
      res.data.forEach((item)=>{
        assignForm.inspectorList.push({
          userId:item.userId,
          username:item.username, 
        })
      })
    
    } 
   
    function close(){
      context.emit('close')
    }

    function handleCancel(){
      context.emit('close')
    }
    async function handleOk(){
      let params = {
        inspector:assignForm.inspector,
        labelTaskSubId:modal.task.id,
        labeler:assignForm.labeler
      }
      
      const {data:res} = await labelTaskAssign(params)
      if(res.code == 0){
        message.success(res.msg)
        context.emit('close')
      }else{
        message.error(res.msg)
      }
    }

    onMounted(() => {
      //assignForm.roleId = instance.ctx.currentRole.roleId
      getLaber()
    })


  
    return{
      modal,
      assignForm,   
      getRoleName,
      getTeamName,
      close,
      handleCancel,
      handleOk
    }
  }
}
</script>


<style lang="less">
 .info-wrap{
    
  }
  .assign-form{
    .form-select{
      width: 200px;
    }
  }
</style>
